export const ACTION_LABELS: Record<string, string> = {
  report_finalised: "Finalised",
  report_unlocked: "Unlocked",
  report_downloaded_admin: "Admin download",
  report_vinci_marked_uploaded: "Marked uploaded to Vinci",
  report_downloaded: "Word download",
  report_previewed: "PDF preview",
};

export const ACTION_BADGE_VARIANT: Record<
  string,
  "secondary" | "success" | "destructive"
> = {
  report_finalised: "success",
  report_unlocked: "destructive",
  report_downloaded_admin: "secondary",
  report_vinci_marked_uploaded: "secondary",
  report_downloaded: "secondary",
  report_previewed: "secondary",
};

export const USER_TYPE_LABELS: Record<string, string> = {
  internal: "Internal",
  expert: "Expert",
  referrer: "Referrer",
  provider: "Provider",
};

export const ACTION_OPTIONS = Object.entries(ACTION_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  })
);

export const USER_TYPE_OPTIONS = Object.entries(USER_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
);
